import { createFileRoute, redirect } from "@tanstack/react-router";

/** Directement vers le volet, sans repasser par `/overview` qui redirige au même endroit. */
export const Route = createFileRoute("/_authed/_dashboard/claims/$claimId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/claims",
      search: { claimId: params.claimId, claimTab: "overview" },
    });
  },
});
